import { render, staticRenderFns } from "./CusInfo.vue?vue&type=template&id=060bff87&scoped=true&"
import script from "./CusInfo.vue?vue&type=script&lang=js&"
export * from "./CusInfo.vue?vue&type=script&lang=js&"
import style0 from "./CusInfo.vue?vue&type=style&index=0&id=060bff87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bff87",
  null
  
)

export default component.exports